export default {
  showMore: {
    id: 'show_more',
    defaultMessage: 'Show more',
  },
}
